// extracted by mini-css-extract-plugin
export default {"container":"ns-z","brandName":"os-z","productName":"ps-z","productNamePdpEnhancements":"qs-z","breakLongProductName":"rs-z"};